import React from 'react';
import PropTypes from 'prop-types';
import {
  BASEMAP_MENU_TYPE_ADDONS,
  BASEMAP_MENU_TYPE_BASEMAPS,
} from '@rsos/constants/basemapMenuTypes';
import BasemapsAddonsBody from '../BasemapsAddonsBody';
import BasemapsAddonsHeader from '../BasemapsAddonsHeader';
import { BasemapsAddonsSwitchContainer } from './BasemapsAddonsSwitch.styles';

/**
 * Sub-component of BasemapMenu - switch for basemaps/addons.
 * @param {Array} addons - List of addons
 * @param {Array} basemaps - List of basemaps
 * @param {String} menuType - Menu type - the value is either 'basemaps' or 'addons'
 * @param {Function} onHandleClick - Basemaps/addons click event
 * @param {String} title - Basemaps/addons title
 */
const BasemapsAddonsSwitch = ({
  addons,
  basemaps,
  menuType,
  onHandleClick,
  title,
}) => {
  return (
    <BasemapsAddonsSwitchContainer
      data-name="basemaps-addons-switch-container"
      justify={title?.length ? 'flex-start' : 'flex-end'}
    >
      <BasemapsAddonsHeader title={title} />
      <BasemapsAddonsBody
        addons={addons}
        basemaps={basemaps}
        menuType={menuType}
        onHandleClick={onHandleClick}
      />
    </BasemapsAddonsSwitchContainer>
  );
};

BasemapsAddonsSwitch.propTypes = {
  addons: PropTypes.arrayOf(
    PropTypes.shape({
      backgroundImage: PropTypes.string,
      displayName: PropTypes.string,
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  basemaps: PropTypes.arrayOf(
    PropTypes.shape({
      backgroundImage: PropTypes.string,
      basemaps: PropTypes.shape({
        light: PropTypes.string,
        dark: PropTypes.string,
      }),
      displayName: PropTypes.string,
      id: PropTypes.string,
      isBasemapVisible: PropTypes.bool,
    }),
  ),
  menuType: PropTypes.oneOf([
    BASEMAP_MENU_TYPE_ADDONS,
    BASEMAP_MENU_TYPE_BASEMAPS,
  ]),
  onHandleClick: PropTypes.func,
  title: PropTypes.string,
};

export default BasemapsAddonsSwitch;
